<template>
  <div class="modal-content" style="width: 600px">
    <div class="modal-header">
      <!-- <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
              aria-hidden="true">×</span></button> -->
        <h2 class="modal-title lg-cond text-center ">{{$t('enjoy_a_free_side_on_us')}}</h2>
    </div>
    <div class="modal-body" v-if="!(status_page == 0 && order_type == $const.DELIVERY)">
      <div v-if="status_page == 2">
        <span>{{$t('free_item_message_2')}}</span>
      </div>
      <div v-else-if="status_page == 3">
        <span>{{$t('free_item_message_3')}}</span>
      </div>
      <div v-else>
        <span>{{$t('free_item_message_1')}}</span>
      </div>
    </div>
    <div class="modal-body" style="border-top: 1px solid #e5e5e5;" v-if="status_page == 0 && order_type == $const.DELIVERY">
      <a @click="addMoreFood()"><img src="https://static.phdvasia.com/my/banners/Pop-up%20image%20for%20chicken%20pops%201080x1080_tiny.jpg" class="xs-mr-5"></a>
    </div>
    <div  class="modal-body" style="border-top: 1px solid #e5e5e5;" v-else-if="free_items.length > 0">
      <h4>{{$t('select_your_side')}}</h4>
      <div v-for="item in free_items" class="xs-flex xs-justify-between flex-wrap pt-10">
        <span>{{item.name}}</span>
        <button @click="AddFreeItemToCart(item)" type="button" class="btn btn-success" style="min-height: 30px;">{{$t('select')}}</button>
      </div>
    </div>
    <div class="modal-footer">
      <div class="xs-flex justify-end" v-if="status_page == 1 || status_page == 0">
        <button @click="addMoreFood()" type="button" class="btn btn-success" style="min-height: 42px;">{{$t('add_more_food')}}</button>
        <button @click="checkout" type="button" class="btn btn-default bg" style="min-height: 42px;">{{$t('no_thanks')}}</button>
      </div>
      <div class="xs-flex justify-end" v-else>
        <button @click="checkout" type="button" class="btn btn-default bg" style="min-height: 42px;">{{$t('no_thanks')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  let vm = null;
  export default {
    props: ['free_items'],
    mounted () {
      vm = this;
      this.$cart.init(this);
      vm.order_type = vm.$disposition.getByKey(vm, 'orderType')
      if(vm.cart.total >= 50 &&  vm.cart.total < 100) {
        vm.status_page = 2
      } else  if(vm.cart.total >= 100) {
        vm.status_page = 3
      } else {
        vm.status_page = 1
      }
    },
    data () {
      return {
        status_page : 1,
        order_type: ''
      }
    },
    watch: {
    },
    methods: {
      checkout() {
        vm.$emit('close')
        vm.$router.push({'name': 'checkout'})
      },

      addMoreFood() {
        vm.$emit('close')
        vm.$root.$emit('showHideCart', false)
        if (vm.status_page === 0) {
          vm.$router.push({'name': 'category', 'params': {'slug': 'sides'}})
        }
      },

      AddFreeItemToCart(data) {
        let item = {
          'group': {},
          'selling_start': data.selling_start
        }
        const products = []

        item.group['outlet_code'] = this.$disposition.getByKey(this,'outletCode','')
        item.group['tier'] = this.$cart.tier
        item.group['order_type'] = this.$cart.order_type
        item.group['order_time'] = this.getTimePickerDate(this)
        item.group['product_type'] = this.$const.CARD_ITEM_TYPE.COMBO
        item.group['combo_id'] = data.uuid
        item.group['quantity'] = 1
        item.group['category_uuid'] = this.$store.getters.category_uuid

        let pro = {
          items: [],
          id: data.uuid,
          item: data,
          quantity: 1,
          name: data.name,
          price: data.price
        }

        for (let i in data.groups) {
          let obj = data.groups[i].items[0]
          let product = {}

          if(Object.values(obj).length > 0){
            product.category_id = null
            product.combo_group_id = data.groups[i].uuid
            product.product_id = obj.uuid
            product.first_id = (obj.first_layers.length > 0) ? obj.first_layers[0].uuid : ''
            product.second_id = (obj.first_layers.length > 0
                    && obj.first_layers[0].second_layers
                    && obj.first_layers[0].second_layers.length > 0) ? obj.first_layers[0].second_layers[0].uuid : ''
            product.toppings = {}
            product.toppings.remove = []
            product.toppings.extra = []
            products.push(product)

            pro.items.push({
              item: obj,
              first: (obj.first_layers.length > 0) ? obj.first_layers[0] : {},
              second: (obj.first_layers.length > 0
                      && obj.first_layers[0].second_layers
                      && obj.first_layers[0].second_layers.length > 0) ? obj.first_layers[0].second_layers[0] : {}
            })
          }
        }
        // Process to make sure that combo_group_id of product is unique
        item.products = this.lodash.uniqBy(products, 'combo_group_id');
        this.smartechAddItem(this, pro , this.$router)
        this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.COMBO)
        this.$cart.insert(this, item)
        this.checkout()
      },

    }
  }
</script>

<style scoped>
  .hut-rewards-header {
    max-width: 420px;
    width: 80%;
    margin:0 auto;
  }
  .alert-danger2 {
    color: #a94442;
    font-weight: bold;
  }

  .free-menu-description{
    cursor: pointer;
  }

  .v--modal-box {
    height: auto !important;
    top: 50px !important;
  }
  .modal-coupon .v--modal {
    min-width: 0px !important;
  }

  .e9ebee {
    background-color: #e9ebee;
  }

  .modal-header {
    padding: 15px 0 0;
  }

  .redeem-menu {
      position: relative;
  }
  .redeem-sub-menu {
      position: absolute;
      left: 450px;
      top: 0;
      width: 250px;
      border: 1px solid #fff;
      background-color: #e9ebee;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalFreeItem.vue